<template>
    <div class="px-3">

        <div v-if="!!formMessage" class="text-body-1 pb-2">{{formMessage}}</div>

         <div v-if="showFeatures === true" class="wire-phone-message grey--text text-body-2 pb-3">
            Номер телефона используется для:
            <br>• Входа в Личный кабинет - вместо номера карты;
            <br>• Напоминания о передаче показаний счетчика;
            <br>• Быстрой смены пароля;
            <br>• Получение электронного чека.
        </div>

        <sg-text-field ref="phone" prefix="+7" label="Номер телефона" v-mask="'### ###-##-##'" type="tel"
            v-model="phone" :rules="phoneRules" @keyup.enter.stop.prevent="doReg1" @keydown.tab.stop.prevent="doReg1"
            @paste.prevent.stop />


        <template v-if="newUser">
            <sg-text-field ref="pin" v-model="pin" type="number" pattern="\d{4}" maxlength="4" inputmode="numeric"
                min="0" class="hide-numbers" label="Пароль" @keydown="onPinKeyDown" @keypress="onPinKeyPress" autocorrect="off"
                @keyup.enter.stop.prevent="$refs.pin2.focus()" @keydown.tab.stop.prevent="$refs.pin2.focus()"
                @paste.prevent.stop :rules="pinRules" />

            <sg-text-field ref="pin2" label="Подтверждение пароля" v-model="pin2" type="number" pattern="\d{4}" min="0"
                maxlength="4" inputmode="numeric" class="hide-numbers" @keyup.enter.stop.prevent="onPin2Enter" autocorrect="off"
                @keydown="onPinKeyDown" @keypress="onPinKeyPress" @keydown.tab.stop.prevent="onPin2Enter"
                @paste.prevent.stop :rules="pin2Rules" />
        </template>


        <div class="d-flex mt-3 justify-end">

            <v-btn class="mr-3" v-if="showCancel === true" color="primary" text @click="cancel">Отмена
            </v-btn>

            <v-btn color="primary" depressed @click="doRegistration" :disabled="!nextEnabled" :loading="loading">
                Далее
            </v-btn>
        </div>

        <div v-if="showEluaWarning" class="grey--text mt-3">
            Нажимая кнопку "Далее", Вы подтверждаете согласие с <a
                href="https://lk.sistemagorod.ru/lk/rules.pdf">Правилами</a>
        </div>



    </div>
</template>

<script>
    import SgCaptcha from './SgCaptcha'
    import SgPhoneConfirm from './SgPhoneConfirm'


    export default {
        props: {
            newUser: {
                type: Boolean,
                default: false,
                required: false
            },
            prePhone: {
                type: String,
                required: false
            },
            prePin: {
                type: String,
                required: false
            },
            loading: {
                type: Boolean,
                required: false,
                default: false
            },
            formMessage: {
                type: String,
                required: false
            },
            showCancel: {
                type: Boolean,
                required: false,
                default: false
            },
            eluaWarning: {
                type: Boolean,
                required: false,
                default: false
            },
            showFeatures: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        mounted() {
            if (this.prePhone) {
                this.$refs.pin.focus()
            } else {
                this.$refs.phone.focus()
            }
        },

        computed: {

            showEluaWarning() {
                return this.eluaWarning === true
            },

            nextEnabled() {
                return this.validate()
            },
        },

        watch: {
            pin() {
                this.$refs.pin2.validate()
            }
        },

        data() {
            return {

                phone: this.prePhone || '',

                pin: this.prePin || '',
                pin2: this.prePin || '',

                pinRules: [
                    v => /^[0-9]{4}$/.test(v) || 'Пароль должен состоять из 4-ех цифр',
                    v => !/\b(\d)\1+\b/.test(v) || 'Пароль не должен состоять из одинаковых повторяющихся цифр',
                    v => !/^(?=\d{4}$)1?2?3?4?5?6?7?8?9?0?$/.test(v) ||
                    'Пароль не должен состоять из последовательно возрастающих цифр'
                ],

                pin2Rules: [
                    v => !!v || 'Необходимо ввести пароль еще раз',
                    v => this.pin == this.pin2 || 'Подтверждение не совпадает с паролем'
                ],

                phoneRules: [
                    v => v && this.unmaskPhone(v).length == 10 ||
                    'Состоит из 10 цифр (без 8 и +7)',
                    v => /^\d{10}$/s.test(this.unmaskPhone(v)) ||
                    'Состоит из 10 цифр (без 8 и +7)'
                ],

            }
        },
        methods: {

            unmaskPhone(maskedPhone) {
                return maskedPhone.replace(/\s|-/g, '')
            },

            focus() {
                this.$refs.phone.focus()
            },

            cancel() {
                /* this.$router.back() TODO поправить */
  /*               this.$router.replace({
                    name: 'wv-away',
                    params: {
                        result: 'cancel'
                    }
                }) */
                this.$emit('cancel')
            },

            validate(dontSetErrors) {

                let fields = ['phone'];

                if (this.newUser) {
                    fields.push(...['pin', 'pin2'])
                }

                let errors = {}

                fields.forEach(field => {
                    let rules = this[field + 'Rules']
                    rules.some(rule => {
                        let res = rule(this[field])
                        if (res != true) {
                            errors[field] = res
                            return true
                        }
                    })
                })

                if (!dontSetErrors) {
                    this.errorMessages = errors
                }

                return Object.values(errors).length == 0
            },

            onPinKeyPress(e) {
                /*         let keyCode = e.keyCode
                        let rule = (keyCode >= 48 && keyCode <= 57 && e.target.value.length < 4) || keyCode == 8
                        if (!rule) {
                          e.preventDefault()
                          e.stopPropagation()
                        } */
                if (e.key) {
                    let rule = (e.key >= 0 && 9 >= e.key && e.target.value.length < 4) || e.key == "Backspace"
                    if (!rule) {
                        e.preventDefault()
                        e.stopPropagation()
                    }

                } else {
                    let keyCode = e.keyCode

                    let rule = (keyCode >= 48 && keyCode <= 57 && e.target.value.length < 4) || keyCode == 8
                    if (!rule) {


                        e.preventDefault()
                        e.stopPropagation()
                    }
                }
            },

            onPinKeyDown(e) {
                if (e.key) {
                    let rule = (e.key >= 0 && 9 >= e.key && e.target.value.length < 4) || e.key == "Backspace"
                    if (!rule) {
                        e.preventDefault()
                        e.stopPropagation()
                    }
                } else {
                    let keyCode = e.keyCode

                    let rule = (keyCode >= 48 && keyCode <= 57 && e.target.value.length < 4) || keyCode == 8
                    if (!rule) {


                        e.preventDefault()
                        e.stopPropagation()
                    }
                }
            },

            doReg1() {
                if (this.newUser) {

                    this.$refs.pin.focus()

                } else {
                    this.doRegistration()
                }
            },

            onPin2Enter() {

                if (!this.showEluaWarning) {
                    this.doRegistration()
                }
            },

            doRegistration() {
                if (!this.validate()) return
                this.$emit('send', {
                    phone: this.unmaskPhone(this.phone),
                    pin: this.pin
                })
            },
        }
    }
</script>

<style>
    /* Маскировать звездочками символы в числовом поле ввода */
    .hide-numbers input[type=number] {
        /*     text-security: disc; */
        -webkit-text-security: disc;
        -moz-webkit-text-security: disc;
        -moz-text-security: disc;
    }

    /* Chrome, Safari, Edge, Opera Скрыть стрелочки на числовом поле ввода*/
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox Скрыть стрелочки на числовом поле ввода */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>